export const baseURL = "https://erashop.codderlab.com/";
// export const baseURL = "http://192.168.1.45:5087/";
export const secretKey = "3dYKe0oGJZ%*rYow?w]s2FU@G#Ng[S";
export const projectName = "EraShop";
